<template>
  <!-- 附件上传 -->
  <div style="width: 100%;">
    <a-upload-dragger
      name="file"
      :multiple="true"
      :action="action"
      :headers="headers"
      :show-upload-list="false"
      @change="handleChange"
      v-if="uploadIf"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">可点击或拖拽上传附件</p>
      <p
        class="ant-upload-hint"
      >支持多个文件、多种格式(.png, .jpg, .txt, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar)多次上传</p>
      <p
        class="ant-upload-hint"
      >（文档文件大小限制在{{ limitObj.fileSize }}以下,图片文件大小限制在{{limitObj.imageSize}}以下）</p>
    </a-upload-dragger>
    <div v-if="fileObj && fileObj.length > 0">
      <a-divider orientation="left">已上传附件列表({{fileObj.length}})</a-divider>
      <a-table
        size="small"
        bordered
        :columns="columns"
        :data-source="fileObj"
        :scroll="{ y: 260 }"
        :pagination="false"
        :rowKey="(record,index)=>{return index}"
      >
        <template slot="operation" slot-scope="text, record, index">
          <a-icon
            v-if="isPreview(record)"
            class="icon-pointer"
            type="eye"
            :style="{ color: 'blue' }"
            title="预览"
            @click="showClick(record, index)"
            style="margin-right: 10px;"
          />
          <a-icon
            class="icon-pointer"
            type="cloud-download"
            :style="{ color: 'blue' }"
            title="下载"
            @click="downloadClick(record)"
            style="margin-right: 10px;"
          />
          <span>
            <!-- title="附件一旦删除不可恢复，是否确定删除？" -->
            <a-popconfirm
              title="是否确定删除附件？"
              ok-text="确定"
              cancel-text="取消"
              v-if="uploadIf"
              @confirm="deleteFileClick(record.id)"
            >
              <a-icon
                class="icon-pointer"
                type="delete"
                style="color: red;cursor:pointer; "
                title="删除"
              />
            </a-popconfirm>
          </span>
          <!-- 四个视图(项目、合同、采购单、客户/供应商)-附件可进行删除 -->
          <!-- title="附件一旦删除不可恢复，是否确定删除？" -->
          <a-popconfirm
            title="是否确定删除附件？"
            ok-text="确定"
            cancel-text="取消"
            v-if="delShowProp"
            @confirm="deleteFileClick(record.id)"
          >
            <a-icon
              class="icon-pointer"
              type="delete"
              style="color: red;cursor:pointer; "
              title="删除"
            />
          </a-popconfirm>
        </template>
      </a-table>
    </div>
    <div v-else>
      <a-divider orientation="center" v-if="uploadIfNo">暂无附件</a-divider>
    </div>
    <!-- <a-modal class="preViewCla" :visible="previewVisible" :footer="null" @cancel="previewCacel">
      <div class="box" ref="box">
        <div class="avatar" ref="avatar">
          <img :src="previewImage" draggable="false" style="width: 100%;">
        </div>
      </div>
    </a-modal>-->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCacel">
      <!-- <img-zoom ref="imgRef"/> -->
      <div class="modal_box">
        <img class="tubiaoLeft" src="../../../static/img/left.png" @click="imgPrev" />
        <!--        <a-icon type="left-circle" class="tubiaoLeft" style="font-size: 50px" @click="imgPrev"/>-->
        <a-carousel
          v-if="yulanArr && yulanArr.length>0"
          arrows
          dots-class="slick-dots slick-thumb"
          ref="img"
        >
          <div v-for="(item, index) in yulanArr" :key="index">
            <div>
              <a-icon type="exclamation-circle" style="color:#ff992b;fontSize:16px;" />温馨提示：附件轮播预览只支持图片类型
              <b>(.png、.jpg)</b>，
              <b>pdf</b>附件可单独
              <b>点击预览</b>！
            </div>
            <div class="carousel-title">
              <b style="color:#096dd9;">{{item.oldName}}</b>（第
              <b>{{index + 1}}</b>张/合计
              <b>{{yulanArr.length}}</b>张)
            </div>
            <img class="img" style="height: auto;width:100%;" :src="item.showImgUrl" />
          </div>
        </a-carousel>
        <img class="tubiaoRight" src="../../../static/img/right.png" @click="imgNext" />
        <!--        <img class="tubiaoRight" src="../../../static/img/left.png">-->
        <!--        <a-icon type="right-circle" class="tubiaoRight" style="font-size: 50px" @click="imgNext" />-->
      </div>
    </a-modal>
  </div>
</template>

<script>
import axios from 'axios'
import imgZoom from './imgZoom.vue'
export default {
  components: { imgZoom },
  props: {
    valName: {
      type: String,
      default: 'fileIds'
    },
    uploadIf: {
      type: Boolean,
      default: true
    },
    uploadIfNo: {
      type: Boolean,
      default: true
    },
    delShowProp: { // 是否支持删除
      type: Boolean,
      default: false
    }
  },
  inject: ['formData'],
  comments: {
    imgZoom
  },
  data () {
    return {
      action: this.$baseURL + '/file/uploadFile',
      headers: {
        Authentication: this.$store.state.account.token
      },
      fileObj: [], // 储存对象 便于数据展示
      fileIdList: [], // 储存id便于数据传输
      columns: [
        {
          width: '40%',
          ellipsis: true,
          title: '文件名',
          dataIndex: 'oldName',
          align: 'center'
        },
        {
          title: '上传时间',
          width: '30%',
          dataIndex: 'time',
          align: 'center'
        }, {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      setCount: 0,
      uploadSuccObj: [], // 存储上传新得附件的对象
      uploadSuccList: [], // 存储上传新得附件的id
      lastDelId: '', // 上次删除id
      previewVisible: false,
      previewImage: '',
      yulanArr: [],
      limitObj: {
        fileSize: '5M',
        imageSize: '5M'
      }
    }
  },
  mounted () {
    this.getLimit()
  },
  methods: {
    handleChange (info) {
      this.uploadSuccObj = []
      this.uploadSuccList = []
      const resFile = info.fileList
      if (info.file.status === 'done') {
        if (info.file.response.status) {
          this.$message.success('上传附件成功')
          // 判断展示的list数组是否包含上传成功的id
          resFile.forEach(item => {
            if (this.fileIdList.indexOf(item.response.file.fileId) === -1) {
              if (item.response.file.fileId !== this.lastDelId) {
                this.uploadSuccObj.push({
                  id: item.response.file.fileId,
                  oldName: item.response.file.oldName,
                  time: item.response.file.time,
                  accessUrl: item.response.file.accessUrl,
                  fileSuffix: item.response.file.fileSuffix
                })
                this.uploadSuccList.push(item.response.file.fileId)
              }
            }
          })
          this.$emit('uploadChange', this.uploadSuccObj)
          this.setValue(true)
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    getFile (idList) { // 查询附件详情
      this.fileObj = []
      this.fileIdList = []
      this.$get('/file/getFileByIds', { fileIds: idList.join(',') }).then(res => {
        if (res.data.status === 1) {
          let resDataList = res.data.data
          resDataList.forEach(element => {
            this.fileObj.push({
              id: element.fileId,
              oldName: element.oldName,
              time: element.time,
              accessUrl: element.accessUrl,
              fileSuffix: element.fileSuffix
            })
            this.fileIdList.push(element.fileId)
          })
        }
      })
      if (idList.length > 0) {
        this.setValue(false)
      }
      setTimeout(() => {
        this.getUrlDetails()
      }, 200)
    },
    getUrlDetails () {
      // 循环附件对象 存储字段-附件查看详情url
      this.fileObj.forEach(element => {
        let previewImage = ''
        const url = this.$baseURL + element.accessUrl
        axios({
          method: 'GET',
          url: url,
          responseType: 'arraybuffer',
          headers: {
            'Authentication': this.$store.state.account.token
          }
        }).then(res => {
          previewImage = 'data:image/png;base64,' + btoa(
            new Uint8Array(res.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          element.showImgUrl = previewImage
        }).catch((e) => {
          console.log(e)
          // this.$message.error('附件"' + element.oldName + '"加载失败！')
        })
      })
    },
    showClick (itemRow, indexVal) {
      if (itemRow.fileSuffix === '.pdf') {
        window.open(this.$baseURL + itemRow.accessUrl)
      } else {
        let arr = []
        this.previewVisible = true
        this.fileObj.forEach((element, index) => {
          if (!element.showImgUrl && ['.png', '.jpg', '.jpeg', '.PNG', '.JPG', '.JPEG'].includes(element.fileSuffix)) {
            this.getImgUrl(this.$baseURL + element.accessUrl).then(res => {
              this.$set(element, 'showImgUrl', res)
            })
          }
          if (['.png', '.jpg', '.jpeg', '.PNG', '.JPG', '.JPEG'].includes(element.fileSuffix)) {
            arr.push(element)
          }
        })

        // 将点击的图片移动到数组首位
        if (indexVal >= 0) {
          arr.forEach((item, index) => {
            if (item.oldName === itemRow.oldName) {
              const clickedItem = arr.splice(index, 1)[0]
              arr.unshift(clickedItem) // 将点击的图片添加到数组开头
              this.yulanArr = arr
            }
          })
        }
      }
    },
    getImgUrl (urlParams) {
      return new Promise((resolve, reject) => {
        let returnVal = ''
        axios({
          method: 'GET',
          url: urlParams,
          responseType: 'arraybuffer',
          headers: {
            'Authentication': this.$store.state.account.token
          }
        }).then(res => {
          returnVal = 'data:image/png;base64,' + btoa(
            new Uint8Array(res.data)
              .reduce((data, byte) => data + String.fromCharCode(byte), '')
          )
          resolve(returnVal)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    previewCacel () {
      this.previewVisible = false
      this.previewImage = ''
      this.yulanArr = []
    },
    // isPreview (itemVal) { // 是否支持预览
    //   if (itemVal.fileSuffix === '.png' || itemVal.fileSuffix === '.jpg' || itemVal.fileSuffix === '.pdf' || itemVal.fileSuffix === '.jpeg') {
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    isPreview (itemVal) { // 是否支持预览
      const supportedTypes = ['.png', '.jpg', '.pdf', '.jpeg', '.PNG', '.JPG', '.PDF', '.JPEG']
      return supportedTypes.includes(itemVal.fileSuffix)
    },
    downloadClick (itemVal) { // 下载附件
      this.$download('/file/downloadFile', { fileId: itemVal.id }, itemVal.oldName)
    },
    deleteFileClick (idVal) { // 删除附件
      // this.$post('/file/deleteFile', { fileId: idVal }).then(res => {
      // if (res.data.status) {
      this.lastDelId = idVal
      // this.$message.success('删除附件成功')
      // 回传数据-被删除的id
      this.$emit('delSucc', idVal)
      // 删除后台传输的id   删除展示的list
      this.fileObj = this.fileObj.filter(item => item.id !== idVal)
      this.fileIdList = this.fileIdList.filter(item => item !== idVal)
      // 判断删除是否为刚上传对象里的数据
      if (this.uploadSuccList.indexOf(idVal) !== -1) {
        this.uploadSuccObj = this.uploadSuccObj.filter(item => item.id !== idVal)
        this.uploadSuccList = this.uploadSuccList.filter(item => item !== idVal)
      }
      this.setValue(true)
      // } else {
      // this.$message.error('删除附件失败')
      // }
      // })
    },
    setValue (val) {
      this.fileIdList = [...this.fileIdList, ...this.uploadSuccList]
      this.fileObj = [...this.fileObj, ...this.uploadSuccObj]
      // 数组对象数据去重
      for (var i = 0; i < this.fileObj.length - 1; i++) {
        for (var j = i + 1; j < this.fileObj.length; j++) {
          if (this.fileObj[i].id === this.fileObj[j].id) {
            this.fileObj.splice(j, 1) // splice删除了一个元素，下标要减一，否则循环会漏掉一个元素(多个相邻的元素 可能会漏掉删除元素)
            j--
          }
        }
      }
      // 数组去重
      this.fileIdList = [...new Set(this.fileIdList)]
      if (val) {
        this.setCount++
        // 数组转string逗号分隔字符串
        const fileStr = this.fileIdList.join(',')
        // 子组件给父组件传值
        this.formData[this.valName] = fileStr
      }
    },
    closeData () {
      this.fileObj = []
      this.fileIdList = []
    },
    imgPrev () {
      this.$refs.img.prev()
    },
    imgNext () {
      this.$refs.img.next()
    },
    getLimit () {
      this.$post('/file/getFileSizeLimit', {}).then(res => {
        // console.log(res)
        if (res.data.status) {
          this.limitObj = res.data.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-body {
  padding: 40px 24px 30px !important;
}
/deep/ .ant-table-thead > tr > th {
  background-color: #efefef !important;
}
/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
/deep/ .ant-modal {
  width: 50% !important;
}
/deep/ .ant-table-header {
  margin-right: -12px !important;
}
.modal_box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  .tubiaoLeft {
    color: #096dd9;
    font-size: 34px;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    left: 25%;
    cursor: pointer;
    z-index: 99;
  }
  .carousel-title {
    text-align: center;
    margin-top: 10px;
    font-size: 16px;
  }
  .tubiaoRight {
    color: #096dd9;
    font-size: 34px;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    right: 25%;
    cursor: pointer;
    z-index: 99;
  }
  .ant-carousel {
    width: 90%;
    margin: 0 10px;
  }
  // 未选中
  /deep/ .ant-carousel .slick-dots li button {
    background: #62bdfa;
  }
  // 选中
  /deep/ .ant-carousel .slick-dots li.slick-active button {
    background: #0288e2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/Upload.vue